import constants from "../Utils/constants";
const initialState = {
  preLeads: [],
  currentPreLead: null,
  notes: [],
  clientPreview: null,
  // status -> count, over everything the current user can see. Statuses with no
  // rows are absent from the map rather than zero, so always read with ?? 0.
  counts: {},
  isGetPreLeadsLoading: false,
  isGetPreLeadByIdLoading: false,
  isAssignPreLeadLoading: false,
  isTransferPreLeadLoading: false,
  isFollowUpPreLeadLoading: false,
  isDismissPreLeadLoading: false,
  isReopenPreLeadLoading: false,
  isPositivePreLeadLoading: false,
  isDeletePreLeadLoading: false,
  isGetNotesLoading: false,
  isSaveNoteLoading: false,
  isClientPreviewLoading: false,
  isCreateClientLoading: false,
  totalLength: 0,
  totalPages: 0,
  currentPage: 1,
};

// assign / transfer / follow_up / dismiss / reopen all return the updated
// pre-lead, so they share one handler: refresh the row in the list and the
// open detail record together, and stop the matching spinner.
const applyUpdatedPreLead = (state, updated, loadingKey) => {
  if (!updated || !updated.id) return { ...state, [loadingKey]: false };

  return {
    ...state,
    [loadingKey]: false,
    preLeads: state.preLeads.map((preLead) =>
      preLead.id === updated.id ? updated : preLead,
    ),
    currentPreLead:
      state.currentPreLead?.id === updated.id ? updated : state.currentPreLead,
  };
};

const preLeadsReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_PRE_LEADS_REQUEST:
      return {
        ...state,
        isGetPreLeadsLoading: true,
      };
    case constants.GET_PRE_LEADS_SUCCESS:
      return {
        ...state,
        isGetPreLeadsLoading: false,
        preLeads: action.payload?.pre_leads || [],
        counts: action.payload?.counts || {},
        totalLength: action.payload?.total_length || 0,
        totalPages: action.payload?.total_pages || 1,
        currentPage: action.payload?.current_page || 1,
      };
    case constants.GET_PRE_LEADS_FAILURE:
      return {
        ...state,
        isGetPreLeadsLoading: false,
      };

    case constants.GET_PRE_LEAD_BY_ID_REQUEST:
      return {
        ...state,
        isGetPreLeadByIdLoading: true,
      };
    case constants.GET_PRE_LEAD_BY_ID_SUCCESS:
      return {
        ...state,
        isGetPreLeadByIdLoading: false,
        // The detail endpoint returns the object unwrapped, not under a key.
        currentPreLead: action.payload || null,
      };
    case constants.GET_PRE_LEAD_BY_ID_FAILURE:
      return {
        ...state,
        isGetPreLeadByIdLoading: false,
      };

    case constants.ASSIGN_PRE_LEAD_REQUEST:
      return { ...state, isAssignPreLeadLoading: true };
    case constants.ASSIGN_PRE_LEAD_SUCCESS:
      return applyUpdatedPreLead(state, action.payload, "isAssignPreLeadLoading");
    case constants.ASSIGN_PRE_LEAD_FAILURE:
      return { ...state, isAssignPreLeadLoading: false };

    case constants.TRANSFER_PRE_LEAD_REQUEST:
      return { ...state, isTransferPreLeadLoading: true };
    case constants.TRANSFER_PRE_LEAD_SUCCESS:
      return applyUpdatedPreLead(
        state,
        action.payload,
        "isTransferPreLeadLoading",
      );
    case constants.TRANSFER_PRE_LEAD_FAILURE:
      return { ...state, isTransferPreLeadLoading: false };

    case constants.FOLLOW_UP_PRE_LEAD_REQUEST:
      return { ...state, isFollowUpPreLeadLoading: true };
    case constants.FOLLOW_UP_PRE_LEAD_SUCCESS:
      return applyUpdatedPreLead(
        state,
        action.payload,
        "isFollowUpPreLeadLoading",
      );
    case constants.FOLLOW_UP_PRE_LEAD_FAILURE:
      return { ...state, isFollowUpPreLeadLoading: false };

    case constants.DISMISS_PRE_LEAD_REQUEST:
      return { ...state, isDismissPreLeadLoading: true };
    case constants.DISMISS_PRE_LEAD_SUCCESS:
      return applyUpdatedPreLead(
        state,
        action.payload,
        "isDismissPreLeadLoading",
      );
    case constants.DISMISS_PRE_LEAD_FAILURE:
      return { ...state, isDismissPreLeadLoading: false };

    case constants.REOPEN_PRE_LEAD_REQUEST:
      return { ...state, isReopenPreLeadLoading: true };
    case constants.REOPEN_PRE_LEAD_SUCCESS:
      return applyUpdatedPreLead(state, action.payload, "isReopenPreLeadLoading");
    case constants.REOPEN_PRE_LEAD_FAILURE:
      return { ...state, isReopenPreLeadLoading: false };

    case constants.POSITIVE_PRE_LEAD_REQUEST:
      return { ...state, isPositivePreLeadLoading: true };
    case constants.POSITIVE_PRE_LEAD_SUCCESS:
      return applyUpdatedPreLead(
        state,
        action.payload,
        "isPositivePreLeadLoading",
      );
    case constants.POSITIVE_PRE_LEAD_FAILURE:
      return { ...state, isPositivePreLeadLoading: false };

    case constants.DELETE_PRE_LEAD_REQUEST:
      return { ...state, isDeletePreLeadLoading: true };
    case constants.DELETE_PRE_LEAD_SUCCESS:
    case constants.DELETE_PRE_LEAD_FAILURE:
      return { ...state, isDeletePreLeadLoading: false };

    case constants.GET_PRE_LEAD_NOTES_REQUEST:
      return { ...state, isGetNotesLoading: true };
    case constants.GET_PRE_LEAD_NOTES_SUCCESS:
      return {
        ...state,
        isGetNotesLoading: false,
        notes: action.payload || [],
      };
    case constants.GET_PRE_LEAD_NOTES_FAILURE:
      return { ...state, isGetNotesLoading: false, notes: [] };

    case constants.CREATE_PRE_LEAD_NOTE_REQUEST:
    case constants.UPDATE_PRE_LEAD_NOTE_REQUEST:
    case constants.DELETE_PRE_LEAD_NOTE_REQUEST:
      return { ...state, isSaveNoteLoading: true };
    case constants.CREATE_PRE_LEAD_NOTE_SUCCESS:
    case constants.UPDATE_PRE_LEAD_NOTE_SUCCESS:
    case constants.DELETE_PRE_LEAD_NOTE_SUCCESS:
    case constants.CREATE_PRE_LEAD_NOTE_FAILURE:
    case constants.UPDATE_PRE_LEAD_NOTE_FAILURE:
    case constants.DELETE_PRE_LEAD_NOTE_FAILURE:
      return { ...state, isSaveNoteLoading: false };

    case constants.PRE_LEAD_CLIENT_PREVIEW_REQUEST:
      return { ...state, isClientPreviewLoading: true };
    case constants.PRE_LEAD_CLIENT_PREVIEW_SUCCESS:
      return {
        ...state,
        isClientPreviewLoading: false,
        clientPreview: action.payload || null,
      };
    case constants.PRE_LEAD_CLIENT_PREVIEW_FAILURE:
      return { ...state, isClientPreviewLoading: false, clientPreview: null };

    case constants.CREATE_PRE_LEAD_CLIENT_REQUEST:
      return { ...state, isCreateClientLoading: true };
    case constants.CREATE_PRE_LEAD_CLIENT_SUCCESS:
      // The response nests the refreshed pre-lead alongside the client.
      return applyUpdatedPreLead(
        state,
        action.payload?.pre_lead,
        "isCreateClientLoading",
      );
    case constants.CREATE_PRE_LEAD_CLIENT_FAILURE:
      return { ...state, isCreateClientLoading: false };

    case "REMOVING_USER_CREDENTIALS":
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
export default preLeadsReducer;
